//LIBRARIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { localize } from 'react-localize-redux';
import styled from 'styled-components';

//COMPONENTS
import ButtonSwitchNavigation from 'components/shared/ButtonSwitchNavigation';
import UserForm from './UserForm';
import UserFormDrawer from './UserFormDrawer';
import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';
import Tabs from 'components/ui/Tabs';

//HELPERS
import { featureEnabled } from 'helpers/ToggleBot';
import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';

const styles = {
  icon: {
    width: '32px',
  },
};

const { TabPane } = Tabs;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-scroll {
    padding: 0;
  }
  .ant-tabs-tab {
    width: calc(85% + 10px);
    font-size: 14px !important;
    background: inherit !important;
  }
  .ant-tabs-nav-container {
    margin-bottom: 20px;
  }
`;
class AddUserForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentForm: 'agent_form',
    };
  }

  componentDidMount() {
    let userType = 'Agent';

    if (this.props.currentUserType === 'maintenance') {
      userType = 'Maintenance';
    }
    this.props.change(this.props.formName, 'user_type', userType);
  }

  handleChange = selectedIndex => {
    if (this.props.currentUserType === 'maintenance') {
      this.props.change(this.props.formName, 'user_type', 'Maintenance');
      return;
    }

    if (selectedIndex === 0) this.props.change(this.props.formName, 'user_type', 'Agent');
    else if (selectedIndex === 1)
      this.props.change(this.props.formName, 'user_type', 'Maintenance');
  };

  onNavigationChange = key => {
    this.setState({ currentForm: key });
  };

  _renderNavigationTabs = () => {
    const { formName, postNewUser, properties, currentUserType, roles, enableSubmit } = this.props;
    return (
      <StyledTabs defaultActiveKey="1" centered onChange={this.onNavigationChange}>
        <TabPane tab={getTranslatedString('landlordPortal.users.table.agent')} key="agent_form">
          {this.state.currentForm === 'agent_form' && (
            <UserFormDrawer
              formName={formName}
              onSubmit={postNewUser}
              properties={properties}
              enableSubmit={enableSubmit}
              initialValues={{
                user_type: 'Agent',
                show_availability: true,
                roles: roles,
                can_manually_assign: true,
                claim_tickets: true,
                view_all_tickets: true,
                can_only_send_by_notice_template: true,
                preference_attributes: { maintenance_notifications: true },
                view_non_maintenance_tickets: false,
                admin: false,
              }}
              currentUserType={currentUserType}
              hideSSO={true}
            />
          )}
        </TabPane>
        <TabPane
          tab={getTranslatedString('landlordPortal.users.form.maintenanceStaff')}
          key="maintenance_form"
        >
          {this.state.currentForm === 'maintenance_form' && (
            <UserFormDrawer
              formName={formName}
              onSubmit={postNewUser}
              properties={properties}
              enableSubmit={enableSubmit}
              initialValues={{
                user_type: 'Maintenance',
                show_availability: true,
                can_manually_assign: true,
                claim_tickets: true,
                view_all_tickets: true,
                can_only_send_by_notice_template: true,
                preference_attributes: { maintenance_notifications: true },
                view_non_maintenance_tickets: false,
                admin: false,
              }}
              currentUserType={currentUserType}
              hideSSO={true}
            />
          )}
        </TabPane>
      </StyledTabs>
    );
  };

  _renderButtonSwitchNavigation = () => {
    let labels;
    let icons;

    if (this.props.currentUserType === 'maintenance') {
      labels = [this.props.translate('landlordPortal.users.form.maintenanceStaff').props.children];
      icons = [this.renderMaintenanceIcon()];
    } else if (featureEnabled('ui.users.maintenance_users')) {
      labels = [
        this.props.translate('landlordPortal.users.form.agent').props.children,
        this.props.translate('landlordPortal.users.form.maintenanceStaff').props.children,
      ];
      icons = [this.renderAgentIcon(), this.renderMaintenanceIcon()];
    } else {
      labels = [this.props.translate('landlordPortal.users.form.agent').props.children];
      icons = [this.renderAgentIcon()];
    }

    return (
      <ButtonSwitchNavigation
        buttonLabels={labels}
        buttonIcons={icons}
        handleChange={this.handleChange}
      />
    );
  };

  render() {
    const { formName, postNewUser, properties, currentUserType } = this.props;
    return (
      <div>
        <RenderIfToggleOff toggle="ui.users.new_create_edit_drawer">
          {this._renderButtonSwitchNavigation()}
        </RenderIfToggleOff>
        <RenderIfToggleOff toggle="ui.users.new_create_edit_drawer">
          <UserForm
            formName={formName}
            onSubmit={postNewUser}
            properties={properties}
            initialValues={{
              show_availability: true,
              can_manually_assign: true,
              claim_tickets: true,
              maintenance_user_type: 'maintenance',
              view_all_tickets: true,
              can_only_send_by_notice_template: true,
              preference_attributes: { maintenance_notifications: true },
              view_non_maintenance_tickets: false,
            }}
            currentUserType={currentUserType}
            hideSSO={true}
          />
        </RenderIfToggleOff>
        <RenderIfToggleOn toggle="ui.users.new_create_edit_drawer">
          {this._renderNavigationTabs()}
        </RenderIfToggleOn>
      </div>
    );
  }

  renderAgentIcon = () => {
    return <img style={styles.icon} src="/agent.svg" alt="Leasing Agent" />;
  };

  renderMaintenanceIcon = () => {
    return <img style={styles.icon} src="/maintenance.svg" alt="Maintenance Staff" />;
  };
}

let ConnectedAddUserForm = connect(
  state => ({
    roles: deepDiver(state, 'landlordUsers.roles'),
  }),
  {
    change,
  }
)(AddUserForm);

export default localize()(ConnectedAddUserForm);
